import React, { Component } from 'react'
import Item from '../../../item'
import names from '../../../../data/names'
import './SearchScreen.css'

export default class SearchScreen extends Component {
    state = {
        value: ""
    }

    filter = e => { 
        this.setState({ value: e.target.value }) 
    }

    itemList = () => {
        const placeholder = Object.keys(names)
        const filterNames = placeholder.filter(e => names[e]
            .name
            .toLowerCase()
            .indexOf(this
                .state
                .value
                .toLowerCase()) > -1)
        const result = filterNames.map(e => {
            const method = this.props.items.map(e=>e.id).indexOf(e) > -1 ? "min" : "add"
            return <Item key={e} type={method} name={names[e].name} id={e} />
        })
        return result.length > 0 
                    ? result 
                    : <div>{`No results are found for : ${this.state.value}.`}</div> 

    }

    render() {
        return (
            <div className="Search">
                <input type="search" autoFocus autoComplete="off" name="searching for the correct items" className={this.itemList() ? "active" : ""} value={this.state.value} onChange={this.filter} placeholder="Search..." />
                <div className='listContainer' ref={e => this.list = e}>
                    {
                        this.state.value.length > 2 
                            ? this.itemList() 
                            : <div>Search box must contain at least three letters</div> 
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen/SearchScreen/index.js